/* global Pikaday, imagesLoaded */
/* eslint max-lines: ["error", 450] */

var Tena = {};

(function($) {
    $.extend(Tena, {
        browser: {
            ie7: false,
            ie8: false,
            ie9: false
        },
        init: function() {
            Tena.detectBrowser();
            Tena.cookiebar();
            Tena.initMasonry();
            Tena.initProductFamilySelector();
            Tena.Header.init();
            Tena.Footer.init();
            Tena.ImageCarousel.init();
            Tena.bindEvents();
            if (Tena.browser.ie7) {
                Tena.ie7fix();
            }
            $('.terms-popup').magnificPopup({
                type: 'inline',
                midClick: true
            });
            $('.popup-iframe').magnificPopup({
                type: 'iframe',
                callbacks: {
                    open: function() {
                        var $contentContainer = $(this)[0].contentContainer;
                        $contentContainer.addClass('popup-custom-iframe');
                    }
                }
            });
            $('.video-popup, .iframe-popup').magnificPopup({
                type: 'iframe',
                iframe: {
                    patterns: {
                        azure: {
                            index: 'azure.com',
                            id: function() {
                                return 0;
                            },
                            src: 'http://www.azure.com/embed/%id%'
                        }
                    }
                }
            });
            $('.gallery-popup a').magnificPopup({
                type: 'image',
                mainClass: 'image-carousel-popup',
                zoom: {
                    enabled: true,
                    duration: 300
                },
                gallery: {
                    enabled: true,
                    tCounter: '%curr% / %total%'
                },
                callbacks: {
                    beforeOpen: function() {
                        // Remove swiper duplicate items and set real index
                        var newItems = this.items.filter(item => {
                            return !$(item).parent().hasClass('swiper-slide-duplicate');
                        });

                        this.items = newItems;
                        this.index = Tena.ImageCarousel.swiper.realIndex;
                    },
                    beforeClose: function() {
                        $('.image-pager li', '.component-image-carousel')
                            .eq(this.index)
                            .trigger('click');
                    },
                    elementParse: function(item) {
                        if (item.el.context.classList.contains('jw-video-popup')) {
                            item.type = 'jwplayer';
                        } else {
                            item.type = 'image';
                        }
                    }
                }
            });
            $('.date-picker').each(function() {
                var picker = new Pikaday({
                    field: this,
                    format: 'YYYY-MM-DD'
                });
                $(this).siblings('.icon-calendar').on('click', function() {
                    picker.show();
                });
            });
            $('.inline-popup-link').magnificPopup({
                type: 'inline',
                showCloseBtn: false
            });

            $('.jw-video-popup').each(function() {
                if (!$(this).parents('.gallery-popup').length) {
                    $(this).magnificPopup({
                        type: 'jwplayer'
                    });
                }
            });
            $('.mobile-menu-left').menu({ speed: 400 });
            $('.mobile-menu-right').menu({ speed: 400, side: 'right' });

            Tena.updateDebugSize();
            // Init components
            $('form').form();
            $('.accordion').accordion();
            $('.toggle-table').toggleTable();
            $('.question-box:not(.question-box-v2)').questionBox();
            $('.question-box.question-box-v2').questionBox2();
            $('.tabs').tabs();
            $('.component-sample-box').sampleBox();
            $('.form-order').formOrder();
            $('.js-toggle-tooltip').tooltip();
            $('.sorter').sorter();
            $('.pie').piechart();
            $('.message').message();
            $('.content-expander').contentExpander();
            $('.js-numeric').keyup(Tena.numeric);
            $.breakpoint.init({
                sizes: ['xxs', 'xs', 'sm', 'md']
            });
            Tena.trackFonts();
            // Init alignment last to let other
            // components finish their layout first
            Tena.Alignment.init();
            // Trigger resize and again when images are loaded
            var $window = $(window);
            imagesLoaded($window, function() {
                $window.resize();
            });
            $window.resize();
            // Ugly workaround to hide navigation based on query parameter
            if ($.urlParam('hidenav')) {
                $('.header, .mobile-header, .footer, .cookiebar').hide();
            }
        },
        bindEvents: function() {
            $(window).on('resize', function() {
                Tena.updateDebugSize();
            });

            // Check all checkboxes in a form - in use in *-history.php pages
            $('body').on('click', '.check-all-input-checkbox', function(e) {
                e.preventDefault();
                var form = $(this).parents('form');
                form.find(':checkbox').prop('checked', true);
            });

            // Print image
            $('.js-print-img').on('click', function(e) {
                var popup = window.open(),
                    imgSource = $(this).attr('href'),
                    $content = $('<div>'),
                    $img = $('<img>').attr('src', imgSource),
                    html = $content.append($img).html();
                popup.document.write(html);
                popup.document.close();
                popup.focus();
                popup.print();
                popup.close();
                e.preventDefault();
            });
        },
        detectBrowser: function() {
            var $body = $('body');
            if ($body.is('.ie9')) {
                Tena.browser.ie9 = true;
            }
            if ($body.is('.ie8')) {
                Tena.browser.ie8 = true;
            }
            if ($body.is('.ie7')) {
                Tena.browser.ie7 = true;
            }
        },
        cookiebar: function() {
            var $cookiebar = $('.cookiebar'),
                $close = $('.cookiebar-close');
            if ($.cookie('cookiebar')) {
                $cookiebar.fadeOut();
            } else {
                $cookiebar.fadeIn();
            }
            $close.on('click', function() {
                $cookiebar.fadeOut();
                $.cookie('cookiebar', true, { expires: 7, path: '/' });
            });
        },
        numeric: function() {
            var numeric = this.value.replace(/[^0-9.]/g, '');
            if ('' + this.value !== numeric) {
                this.value = numeric;
            }
        },
        updateDebugSize: function() {
            var $size = $('#debug-size');
            if (!$size.size()) {
                $size = $('<div id="debug-size" />');
                $size.css({
                    position: 'fixed',
                    top: 5,
                    left: 5,
                    zIndex: 999999,
                    backgroundColor: 'rgba(255, 255, 255, 0.3)',
                    fontSize: 12,
                    padding: 2,
                    border: '1px solid rgba(255, 255, 255, 0.5)',
                    color: '000',
                    display: 'none'
                });
                $('body').prepend($size);
            }
            $size.html($(window).width() + 'x' + $(window).outerHeight());
        },
        initMasonry: function() {
            if (Tena.browser.ie7) {
                return;
            }
            var $masonry = $('.masonry'),
                itemClass = '.masonry-item',
                sizerClass = '.grid-sizer';
            if ($masonry.length === 0) {
                return;
            }
            // Remove fallback
            $masonry.find(sizerClass).removeClass('hide');
            $masonry.find('.align-height').removeClass('align-height');
            // Init masonry
            imagesLoaded($masonry.get(0), function() {
                $masonry.masonry({
                    columnWidth: sizerClass,
                    itemSelector: itemClass,
                    gutter: 0
                });
            });
        },
        initProductFamilySelector: function() {
            var $accordion = $('.accordion-product-family-selector'),
                $select,
                optionGroups = [];
            if (!$accordion.size()) {
                return;
            }
            $select = $('select[name=product_name]').eq(0);
            $select.find('optgroup').each(function() {
                optionGroups.push($(this));
            });
            $accordion.on('click', '.product-family-item', function() {
                var id = $(this).data('family-id'),
                    $selectedOptionGroup = false;
                if ($(this).hasClass('selected')) {
                    $accordion.find('.product-family-item').removeClass('selected');
                    $select.find('optgroup').remove();
                    $.each(optionGroups, function(index, $element) {
                        $select.append($element);
                    });
                    if (!Tena.browser.ie7) {
                        $select.selectOrDie('update');
                    }

                    return;
                }
                $accordion.find('.product-family-item').removeClass('selected');
                $(this).addClass('selected');
                $.each(optionGroups, function(index, $element) {
                    // eslint-disable-next-line eqeqeq
                    if ($element.data('id') == id) {
                        $selectedOptionGroup = $element;

                        return false;
                    }
                });
                if ($selectedOptionGroup.size() === 1) {
                    $select.find('optgroup').remove();
                    $select.append($selectedOptionGroup);
                    $select.prop('selectedIndex', 0);
                    if (!Tena.browser.ie7) {
                        $select.selectOrDie('update');
                    }
                }
            });
        },
        ie7fix: function() {
            Tena.fixColWidth($('body'));
            $(window).on('tabs.changed', function(e, data) {
                Tena.fixColWidth(data.show);
            });
            $(window).on('accordion.changed', function(e, data) {
                Tena.fixColWidth(data.show);
            });
            $(window).on('breakpoint.changed', function() {
                Tena.fixColWidth($('body'));
            });
            $(window).on('submenu.changed', function(e, data) {
                Tena.fixColWidth(data.show);
            });
        },
        fixColWidth: function($el, timeout) {
            var $cols =
                    typeof $el === 'undefined'
                        ? $('[class*=col-]')
                        : $el.find('[class*=col-]'),
                $col,
                width,
                fullWidth,
                diff,
                newWidth;
            timeout = timeout || 100;
            $cols.each(function() {
                this.style.removeAttribute('width');
            });
            window.fixColWidthTimeout = setTimeout(function() {
                $cols.each(function() {
                    $col = $(this);
                    width = $col.width();
                    fullWidth = $col.outerWidth();
                    diff = fullWidth - width;
                    newWidth = width - diff;
                    $col.css('width', newWidth);
                });
            }, timeout);
        },
        // Comply with fonts.com EULA
        // http://blog.toxa.de/archives/460
        // http://www.fonts.com/info/legal/eula/web-fonts
        trackFonts: function() {
            var mtiTracking = document.createElement('script');
            mtiTracking.type = 'text/javascript';
            mtiTracking.async = 'true';
            mtiTracking.src =
                ('https:' === document.location.protocol ? 'https:' : 'http:') +
                '//fast.fonts.net/t/trackingCode.js';
            $('head').append(mtiTracking);
        }
    });
    $(function() {
        Tena.init();
    });
})(jQuery);
